import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=c745df32&scoped=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"
import style0 from "./modal.vue?vue&type=style&index=0&id=c745df32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c745df32",
  null
  
)

export default component.exports